export const selectAllLocations = ({ LocationsSlice: oState }) => oState?.aLocations;
export const selectStatusLocations = ({ LocationsSlice: oState }) => oState?.bStatus;
